/*
 * Aperçu cliquable de la bande d'invitation au quizz.
 *
 * Les réponses sont de vraies ancres : sans ce script, un clic ouvre déjà le
 * quizz avec la bonne réponse. Le script n'ajoute que le confort, montrer le
 * choix se cocher avant de partir.
 */

(function () {
  'use strict';

  var DELAI = 620;

  function activer(apercu) {
    if (apercu.dataset.quizzTeaserPret === 'oui') return;
    apercu.dataset.quizzTeaserPret = 'oui';

    var liens = apercu.querySelectorAll('[data-quizz-teaser-choix]');
    if (!liens.length) return;

    var reduire = typeof window.matchMedia === 'function'
      && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    liens.forEach(function (lien) {
      lien.addEventListener('click', function (evenement) {
        /* On laisse le navigateur faire son travail sur un clic du milieu, un
           clic avec une touche de modification, ou une ouverture en onglet. */
        if (evenement.defaultPrevented || evenement.button !== 0
          || evenement.metaKey || evenement.ctrlKey || evenement.shiftKey || evenement.altKey) {
          return;
        }
        if (reduire) return;

        evenement.preventDefault();

        apercu.querySelectorAll('.quizz-teaser__apercu-tuile').forEach(function (tuile) {
          tuile.classList.remove('is-choisie');
        });
        var tuile = lien.closest('.quizz-teaser__apercu-tuile');
        if (tuile) tuile.classList.add('is-choisie');
        apercu.classList.add('is-en-route');

        window.setTimeout(function () {
          window.location.href = lien.href;
        }, DELAI);
      });
    });
  }

  function demarrer() {
    document.querySelectorAll('.quizz-teaser__apercu--jouable').forEach(activer);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', demarrer);
  } else {
    demarrer();
  }

  /* L'éditeur de thème réinjecte la section à chaque modification. */
  document.addEventListener('shopify:section:load', demarrer);
  document.addEventListener('krown:main-collection-grid:filtered', demarrer);
})();
